import React from 'react';
import * as RadixTabs from '@radix-ui/react-tabs';

interface IProps {
  data: {
    label: string;
    key: string;
  }[];
  onChange: (v: string) => void;
}

export const Tabs = ({ data, onChange }: IProps) => {
  return (
    <RadixTabs.Root className="w-full max-w-md mx-1 mt-2" defaultValue={data[0].key} onValueChange={onChange}>
      <RadixTabs.List className="flex border-gray-300">
        {data.map((i) => (
          <RadixTabs.Trigger
            key={i.key}
            value={i.key}
            className="px-4 py-2 text-sm font-medium text-gray-600 rounded-t-md hover:text-blue-500 data-[state=active]:text-blue-600 data-[state=active]:border-b-2 data-[state=active]:border-blue-500"
          >
            {i.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
    </RadixTabs.Root>
  );
};
